// jQuery_T4NT(document).ready(function($) {

//      /**
//      * Variant selection changed
//      */
// 	  $( document ).on( "variant:change", function( evt, variant ) {
// 	    //console.log( variant );
// 	  });

// });

document.addEventListener("DOMContentLoaded", function() {
    document.querySelector('.moreless-button').addEventListener('click', function() {
        var moreText = document.querySelector('.moretext');
        var button = this;
        
        if (moreText.style.display === "none" || moreText.style.display === "") {
            moreText.style.display = "block";
            button.textContent = "Read less";
        } else {
            moreText.style.display = "none";
            button.textContent = "Read more";
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {

  document.querySelector(".shopify-whatsApp a").addEventListener("click", function() {
    if (typeof gtag === 'function') {
      gtag('event', 'click', {
        'event_category': 'Button',
        'event_label': 'WhatsApp Button',
        'value': 1
      });
    }
  });
});
